// extracted by mini-css-extract-plugin
export default {"page":"page_page__v9b8l","logo":"page_logo__5pval","title":"page_title__19clK"};